import { App } from 'vue'
// import { Env } from '@loca/mfe-utils'
import { getEnv } from '@nio-wad/hooks'
import sensors from 'sa-sdk-javascript'

export function initSensors() {
  // 初始化神策埋点
  const env = getEnv()
  const project = env === 'prod' ? 'nioapp_prod' : 'nioapp_test'
  sensors.init({
    server_url: `https://sensors.nio.com/sa?project=${project}`,
    is_track_single_page: false,
    use_client_time: true,
    send_type: 'beacon',
    heatmap: {
      // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'default',
      // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'not_collect',
    },
  })

  // 注册公共参数
  sensors.registerPage({
    appId: '100119',
  })
}

// export default sensors;

export default ({ app }: { app: App<any> }) => {
  //   console.log('app', app)
}
